"use strict";

/* burger menu */

let menuButtons = document.querySelectorAll(".btn-menu");
for(let menuButton of menuButtons){
    menuButton.addEventListener("click", toggleNavigation);
}

function toggleNavigation(){
    if(document.body.hasAttribute("data-menu")){
        document.body.removeAttribute("data-menu");
    }else{
        document.body.setAttribute("data-menu", true);
    }
}


// audio palyer
const audioPlayer = document.querySelector(".audio-player");
const audioPlayer2 = document.querySelector(".audio-player-2");
const audioPlayer3 = document.querySelector(".audio-player-3");
const audio = new Audio(
  "https://www.alexandra-eischen.be/body-high.mp3"
);
const audio2 = new Audio(
    "https://www.alexandra-eischen.be/ciel.mp3"
  );
  const audio3 = new Audio(
    "https://www.alexandra-eischen.be/take-control.mp3"
  );



const timeline = audioPlayer.querySelector(".timeline");
const timeline2 = audioPlayer2.querySelector(".timeline-2");
const timeline3 = audioPlayer3.querySelector(".timeline-3");
timeline.addEventListener("click", e => {
  const timelineWidth = window.getComputedStyle(timeline).width;
  const timeToSeek = e.offsetX / parseInt(timelineWidth) * audio.duration;
  audio.currentTime = timeToSeek;
}, false);
timeline2.addEventListener("click", e => {
    const timelineWidth = window.getComputedStyle(timeline).width;
    const timeToSeek = e.offsetX / parseInt(timelineWidth) * audio2.duration;
    audio2.currentTime = timeToSeek;
}, false);
timeline3.addEventListener("click", e => {
    const timelineWidth = window.getComputedStyle(timeline).width;
    const timeToSeek = e.offsetX / parseInt(timelineWidth) * audio3.duration;
    audio3.currentTime = timeToSeek;
}, false);


setInterval(() => {
  const progressBar = audioPlayer.querySelector(".progress");
  progressBar.style.width = audio.currentTime / audio.duration * 100 + "%";
}, 500);
setInterval(() => {
    const progressBar2 = audioPlayer2.querySelector(".progress-2");
    progressBar2.style.width = audio2.currentTime / audio2.duration * 100 + "%";
  }, 500);
setInterval(() => {
const progressBar3 = audioPlayer3.querySelector(".progress-3");
progressBar3.style.width = audio3.currentTime / audio3.duration * 100 + "%";
}, 500);

const playBtn = audioPlayer.querySelector(".controls .toggle-play");
const playBtn2 = audioPlayer2.querySelector(".controls-2 .toggle-play-2");
const playBtn3 = audioPlayer3.querySelector(".controls-3 .toggle-play-3");
playBtn.addEventListener( "click", () => {
    if (audio.paused) {
      playBtn.classList.remove("play");
      playBtn.classList.add("pause");
      audio.play();
    } else {
      playBtn.classList.remove("pause");
      playBtn.classList.add("play");
      audio.pause();
    }
},false);
playBtn2.addEventListener(
    "click",
    () => {
      if (audio2.paused) {
        playBtn2.classList.remove("play");
        playBtn2.classList.add("pause");
        audio2.play();
      } else {
        playBtn2.classList.remove("pause");
        playBtn2.classList.add("play");
        audio2.pause();
      }
    },
    false
  );
playBtn3.addEventListener(
"click",
() => {
    if (audio3.paused) {
    playBtn3.classList.remove("play");
    playBtn3.classList.add("pause");
    audio3.play();
    } else {
    playBtn3.classList.remove("pause");
    playBtn3.classList.add("play");
    audio3.pause();
    }
},
false
);


// slider
const btnPrev = document.querySelector(".slider__btn--prev");
const btnNext = document.querySelector(".slider__btn--next");

btnNext.addEventListener('click', next);
btnPrev.addEventListener('click', prev);


function next(){
    let elShow = document.querySelector(".slider__el--show");
    let elNext = elShow.nextElementSibling;

    elShow.classList.remove("slider__el--show");

    if(elNext){
        elNext.classList.add("slider__el--show");
    }else{
        let elFrist = elShow.parentNode.firstElementChild;
        elFrist.classList.add("slider__el--show");
    }
}   

function prev(){
    let elShow = document.querySelector(".slider__el--show");
    let elPrev = elShow.previousElementSibling;

    elShow.classList.remove("slider__el--show");

    if(elPrev){
        elPrev.classList.add("slider__el--show");
    }else{
        let elLast = elShow.parentNode.lastElementChild;
        elLast.classList.add("slider__el--show");
    }
}   

// TOUCH TAB

const slider = document.querySelector(".slider");
const hammerSlider = new Hammer(slider);


hammerSlider.on("swipeleft", next);
hammerSlider.on("swiperight", prev);